<template>
    <flex-layout>
        <CompanyModal/>
        <page-header heading="Company" action="Add" toggle="offcanvas" target="#offcanvasCreate" :guard="this.$route.meta.guard"
            @click="setCreateForm" />

        <CompanyTable :tableHeading="tableHeading" />
    </flex-layout>
</template>
  
<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import CompanyTable from "@/components/Company/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import CompanyModal from "@/components/Company/modal.vue";
export default {
    name: "Company",
    components: {
        PageHeader,
        FlexLayout,
        CompanyTable,
        CompanyModal
    },
    data() {
        return {
            tableHeading: [
                {
                    heading: "Name",
                },
                {
                    heading: "Description",
                },
                {
                    heading: "Type",
                },
                {
                    heading: "Status",
                },
            ],
        };
    },
   
    methods: {
        setCreateForm() {
            this.$root.$emit('CREATE');
        },
    }
};
</script>
  